/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Navbar } from "../../components/navbar";
import Arrow from "@material-ui/icons/ArrowBack"
import { RefDialogBox } from "../../components/refDialog";
import { ImgModalBox } from "../../components/imgModal";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../services/auth.service";
import { STATUS } from "../../common/constant";
import Pagination from "../../components/Pagination";
import Loader from "../../components/Loader";

type TProp = {
    userid: string
    username: string
}
export const UserManagement: React.FC<TProp> = ({ userid, username }) => {

    const [page, setPage] = useState<number>(1);
    const [data, setData] = useState<any>();
    const [limit] = useState<number>(5);
    const [show, setShow] = useState<boolean>(false)
    const [showImg, setShowImg] = useState<boolean>(false)
    const [img, setImg] = useState<any | null>(null)
    const authenticationService = new AuthService();
    const [count, setCount] = useState<number>(0)
    const [loader, setLoader] = useState<boolean>(false)

    const getAccount = async () => {
        try {
            setLoader(true)
            const accountResponse: any = await authenticationService.getAccount(userid, page, limit);
            if (accountResponse.status === STATUS.SUCCESS) {
                setData(accountResponse.data.account_details)
                setCount(Math.ceil(accountResponse.data.total / 5))
                setLoader(false)
            }
        }
        catch (error) {

        }
    }

    // const offers = async () => {
    //     try {
    //         const offerResponse: any = await authenticationService.Offers(userid);
    //         if (offerResponse.status === STATUS.SUCCESS) {
    //             console.log(offerResponse.data.Account_details)
    //         }
    //     } catch (error) {

    //     }
    // }

    useEffect(() => {
        getAccount()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    const navigate = useNavigate()

    const handleIncident = (eve: any, ele: any) => {
        if (!!eve.target?.src) {
            //pass
        } else {
            navigate("/incidentDetails", { state: ele })
        }
    }

    const handleImgModal = () => {
        setShowImg(true)
    }

    useEffect(() => {
        getAccount()
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="account-page">
                <Navbar noAds Admin={true} />
                <h5 className="account-heading">USER MANAGEMENT</h5>
                <div className="account-con">
                    <div className="table" >
                    <div className="table-header-wraper">
                            <h5 className="account-table-heading">{username} Rescue Log</h5>
                        </div>
                        <div >
                            <table className="table-wraper">
                                <thead className="head-wraper">
                                    <tr>
                                        <th style={{ width: "15%" }} ><p>Incident Details</p></th>
                                        <th style={{ width: "25%" }}><p>Attachments</p></th>
                                        <th style={{ width: "25%" }}><p>Comments</p></th>
                                        <th style={{ width: "20%" }}><p>Date</p></th>
                                        <th style={{ width: "15%" }}><p>Reported by</p></th>
                                    </tr>
                                </thead>
                                {data?.map((element: any, index: number) => {
                                    return (
                                        <tbody
                                            key={index}
                                            id={`${index}`}
                                            onClick={(event: any) => { handleIncident(event, element) }}
                                            className="body-wraper" style={index % 2 ? { backgroundColor: "#F1F0F0", cursor: "pointer" } : { backgroundColor: "white", cursor: "pointer" }}
                                        // onMouseOver={(event) => {console.log(event.target)}}
                                        >
                                            <tr style={{ width: "15%", display: "flex", justifyContent: "center" }}><td>{element.incident_details}</td></tr>
                                            <tr style={{ width: "25%", display: "flex", justifyContent: "center" }}>
                                                <td>
                                                    {element.attachments ?
                                                        <img src={element.attachments} className="attachment-img" onClick={() => { setImg(element.attachments); handleImgModal(); }} alt="Not found" />
                                                        : <p>No Attachments Provided</p>
                                                    }
                                                </td>
                                            </tr>
                                            <tr style={{ display: "flex", justifyContent: "center", width: "25%" }}><td>{element.comments}</td></tr>
                                            <tr style={{ display: "flex", justifyContent: "center", width: "20%" }}><td>{element.data}</td></tr>
                                            <tr style={{ display: "flex", width: "15%", justifyContent: "center" }}><td>{element.by}</td></tr>
                                        </tbody>
                                    )
                                })}
                            </table>
                        </div>
                        <Pagination setPage={setPage} page={page} count={count} />
                        <div className="table-header-wraper">
                            <h5 className="account-table-heading" style={{ fontWeight: 700 }}>{username} Stats</h5>
                        </div>
                        <table className="table-wraper">
                            <thead>
                                <tr className="head-wraper">
                                    <th style={{ width: "25%" }} ><p>Hero Status</p></th>
                                    <th style={{ width: "50%" }}></th>
                                    <th style={{ width: "25%" }}><p>Number</p></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="body-wraper" style={{ backgroundColor: "white", width: "100%" }}>
                                    <td className="body-content" style={{ display: "flex", justifyContent: "center", width: "25%" }} >
                                        <p>Total Parking Hero Missions</p>
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ textAlign: "center", width: "25%" }}>
                                        <p>20</p>
                                    </td>
                                </tr>
                                <tr className="body-wraper" style={{ backgroundColor: "#F1F0F0" }}>
                                    <td className="body-content" style={{ display: "flex", justifyContent: "center", width: "25%" }}>
                                        <p>Successful Parking Hero Missions</p>
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ width: "25%" }}>
                                        <div className="sub-table" >
                                            <div className="sub-table-body">
                                                <table>
                                                    <tbody>
                                                        <tr style={{ width: "50%" }}><td>Send </td>
                                                            <td><Arrow style={{ transform: "rotate(90deg)" }} /></td><td> 5</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="sub-table-body">
                                                <table>
                                                    <tbody>
                                                        <tr style={{ width: "50%" }}><td>Received </td>
                                                            <td><Arrow style={{ transform: "rotate(-90deg)" }} /> </td><td> 5</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="body-wraper" style={{ backgroundColor: "white" }}>
                                    <td className="body-content" style={{ display: "flex", width: "25%", justifyContent: "center" }} >
                                        <p>Referrals </p>
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ width: "25%" }}><p>5</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div >
                </div >
                <div className="add-con">
                </div>
                {show && <RefDialogBox show={show} setShow={setShow} />}
                {showImg && <ImgModalBox show={showImg} setShow={setShowImg} img={img} />}
                {loader && <Loader />}
            </div >
        </>
    )
}